<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i">The Pashtun Tribes in</a></h1><a id="page_i">
<h1 class="title1">AFGHANISTAN</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?f004f1ae